<template>
  <div class="header-button">
    <template>
      <slot name="btn">
        <custom-button type="primary" plain>
          <span>Button</span>
        </custom-button>
      </slot>
    </template>
  </div>
</template>

<script>
import CustomButton from "@/components/header/components/customButton";
import responsiveMixin from "@/mixins/responsive";

export default {
  data() {
    return {}
  },
  mixins: [responsiveMixin],
  props: {},
  components: { CustomButton },
  computed: {},
  mounted() { },
  methods: {},
}
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>